module.exports = __webpack_public_path__ + "img/header-memoireRingsExclusive@2x.a24b42e.webp";